import styled from '@emotion/styled';
import { boxSizes, colors, colorVariables, fontWeights, gutterSizes, lineHeights } from '@gumtree/ui-library/src/base/theme';

export const ServiceFormContainer = styled.div`
    height: calc(100% - 48px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const ServiceFormContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0 ${gutterSizes.large};

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE & Edge */

    &::-webkit-scrollbar {
        display: none;
    }

    .search-bar {
        position: relative;
        
        .icon--clear {
            border: none;
            background: none;
            position: absolute;
            right: ${gutterSizes.xxlarge};
            top: 50%;
            transform: translateY(-50%) translateX(-${gutterSizes.xlarge});
            cursor: pointer;
        }
    }
`;

export const SearchButton = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid ${colorVariables.textLight};
    border-radius: ${boxSizes.borderRadius4};
    background: ${colors.white};
    padding: ${gutterSizes.medium} ${gutterSizes.large};
    height: ${boxSizes.boxHeight48};
    cursor: pointer;
    outline: none;
    transition: border 0.2s;
    font: inherit;
    &:hover, &:focus {
        border-color: ${colors.darkGrey};
    }
`;

export const SearchButtonText = styled.span`
    margin-left: ${gutterSizes.medium};
`;

export const InfoBox = styled.div`
    display: flex;
    align-items: center;
    background: ${colorVariables.backgroundLighter};
    border-radius: ${boxSizes.borderRadius8};
    padding: ${gutterSizes.base} ${gutterSizes.large};
    margin: ${gutterSizes.xlarge} 0;
`;

export const InfoIcon = styled.span`
    width: ${boxSizes.boxHeight24};
    height: ${boxSizes.boxHeight24};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${gutterSizes.medium};
    svg {
        width: ${boxSizes.boxHeight24};
        height: ${boxSizes.boxHeight24};
    }
`;

export const InfoText = styled.span`
    color: ${colorVariables.mainSecondary};
    line-height: ${lineHeights.base};
`;

export const ServiceFormButton = styled.div<{ selectedService?: string }>`
    border-top: 1px solid ${colorVariables.borderLight};
    padding: ${gutterSizes.large};

    button {
        width: 100%;
        height: ${boxSizes.boxHeight48};
        font-weight: ${fontWeights.bold};
        border: none;
        border-radius: ${boxSizes.borderRadius};
        background-color: ${props => props.selectedService ? colors.gtGreen : colors.surfaceHover};
        color: ${props => props.selectedService ? colorVariables.textHighlightedDescription : colorVariables.textSecondary};
        cursor: ${props => props.selectedService ? 'pointer' : 'not-allowed'};
        transition: background-color 0.3s ease;

        &:hover {
            opacity: ${props => props.selectedService ? '0.9' : '1'};
        }
    }
`;
